import { useCallback, useEffect, useState } from 'react'
import { omit } from 'lodash'
import axios from 'axios'
import config from 'config'
import { useDebouncedCallback } from 'use-debounce'

const useAgendaData = ({ newPage, limit, filters }) => {
  const [state, setState] = useState({
    fetchedFirstTime: false,
    isFetching: false,
    isFetchingOtherPages: false,
    page: 0,
    rowsPerPage: 10,
    items: [],
    total: 0,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: !s.fetchedFirstTime,
      isFetchingOtherPages: s.fetchedFirstTime,
    }))
  }, [setState])

  const setSuccessFetching = useCallback(
    (items, total, page, rowsPerPage) => {
      setState((s) => ({
        ...s,
        page: page,
        rowsPerPage: rowsPerPage,
        items: items,
        total: total,
        fetchedFirstTime: true,
        isFetching: false,
        isFetchingOtherPages: false,
        error: null,
      }))
    },
    [setState]
  )

  const fetchData = useDebouncedCallback(async () => {
    setStartFetching()

    const result = await axios.get(`${config.apiBaseUrl}agenda`, {
      params: {
        page: newPage,
        limit,
        filters: JSON.stringify(omit(filters, ['order'])),
        sort: filters.order?.column,
        direction: filters.order?.direction,
      },
    })

    setSuccessFetching(
      result.data.body.items,
      result.data.body.total,
      newPage,
      limit
    )
  }, 100)

  useEffect(() => {
    fetchData()
  }, [setStartFetching, setSuccessFetching, newPage, limit, fetchData, filters])

  return {
    page: state.page,
    rowsPerPage: state.rowsPerPage,
    items: state.items,
    total: state.total,
    isFetching: state.isFetching,
    isFetchingOtherPages: state.isFetchingOtherPages,
  }
}

export default useAgendaData
